export default __webpack_public_path__ + "static/media/construction.4178a06b.jpg";